export const Bool2Number = (data) => {
    if (data === 1) {
        return true;
    }
    return false;
}

export const ShowBoolean = (data, params) => {
    if (data === 1) {
        return params.hasOwnProperty("true") ? params.true : "Sim";
    }
        return params.hasOwnProperty("false") ? params.false : "Não";
}

export const String2Float = (data) => {
    return parseFloat(data);
}

export const dateFormat2Save = (date, delimiter='-') => {
    let us_date = date.split('/');
    return us_date[2] + delimiter + us_date[1] + delimiter + us_date[0];
}

export const dateFormat2Show = (date, delimiter='-') => {
    let us_date = date.split('/');
    return us_date[2] + delimiter + us_date[1] + delimiter + us_date[0];
}

// export const setInitialValue = (value, type) => {
//     switch (type) {
//         case 'boolean':
//         case 'radio_enum':
//             return (_.isNull(value) || _.isUndefined(value) ? null : '' + value);
//         case 'text':
//         case 'number':
//         case 'select':
//         case 'enum':
//             return (value === '' ? null : value);
//         case 'date':
//             return (_.isNull(value) || _.isUndefined(value) || value === '' ? null : moment(ShowDateFormat(value), FormatDate));
//         case 'datetime':
//             return (_.isNull(value) || _.isUndefined(value) || value === '' ? null : moment(ShowDateFormat(value), FormatDate));

//         default:
//             return undefined;
//     }
// }
